import { ComponentType, MessageType } from '../../../types/enum';

export function createPlainSystemMessage({
  messageId = '',
  messageTitle = '',
  messageSubType = '',
}): Message {
  return {
    time: new Date(),
    messageId,
    messageType: MessageType.SYSTEM,
    messageSubType: messageSubType ? messageSubType : '',
    messageComponent: {
      component: ComponentType.SystemMessageComponent,
      componentData: {
        messageTitle: messageTitle,
      },
    },
  };
}
